import Fab from '@material-ui/core/Fab';
import React from 'react';
import styles from '../styles/quote.module.scss'

function Quote(props) {
    return (
        <div className={styles.quoteBody}>
          <p className={styles.quote}>{props.quote}</p>
          <p className={styles.name}>{props.personName}</p>
        </div>
    )
}

export default Quote